import styled from 'styled-components';

export const BottomSheetWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: ${({ height }) => height + 'px'};
  max-height: 80%;
  transition: height 0.3s ease-in-out;
  --webkit-transform: translate3d(0, 0, 0);
  z-index: 1002;
`;

export const BottomSheetHeaderBlock = styled.div`
  position: fixed;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  border-top-left-radius: ${({ theme }) => theme.radius.xl};
  border-top-right-radius: ${({ theme }) => theme.radius.xl};
  z-index: 5;
`;

export const BottomSheetContent = styled.div`
  background-color: #ffffff;
  border-top-left-radius: ${({ theme }) => theme.radius.xl};
  border-top-right-radius: ${({ theme }) => theme.radius.xl};
  height: 100%;
  overflow: auto;
`;

export const BottomSheetTitle = styled.div`
  display: flex;
  justify-content: center;
  font-size: ${({ theme }) => theme.fontSize.xl};
  font-weight: ${({ theme }) => theme.fontWeight.semiBold};
  color: ${({ theme }) => theme.colors.oxfordBlue};
  margin-top: ${({ theme }) => theme.spacing.m};
`;

export const BottomSheetChildren = styled.div`
  padding-top: 70px;
  padding-bottom: ${({ theme }) => theme.spacing.m};
`;

export const BottomSheetHeader = styled.a`
  display: flex;
  justify-content: flex-end;
  font-size: ${({ theme }) => theme.fontSize.m};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  color: ${({ theme }) => theme.colors.eerieBlack};
  padding-right: ${({ theme }) => theme.spacing.m};
  padding-top: ${({ theme }) => theme.spacing.m};
`;

export const BottomSheetOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(31, 31, 31, 0.9);
  z-index: 998;
`;

export const BottomSheetLineSeparator = styled.hr`
  margin-top: ${({ theme }) => theme.spacing.m};
`;
